module.exports = __webpack_public_path__ + "img/ic_blank_data.4b14d605.svg";